exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-button.uu5-common-selected {\n  -webkit-box-shadow: 0 0 0 1px #66afe9;\n  -moz-box-shadow: 0 0 0 1px #66afe9;\n  box-shadow: 0 0 0 1px #66afe9;\n}\n.btn.active.focus,\n.btn.active:focus,\n.btn.focus,\n.btn:active.focus,\n.btn:active:focus,\n.btn:focus {\n  outline: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/button.less
// module id = 193
// module chunks = 0